import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/illustration.png'


const _hoisted_1 = { class: "min-h-[70vh] flex items-center justify-center px-4" }
const _hoisted_2 = { class: "relative w-full rounded-3xl p-10 overflow-hidden" }
const _hoisted_3 = { class: "relative z-10 text-center flex flex-col items-center gap-4" }
const _hoisted_4 = { class: "flex flex-col md:flex-row gap-3 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          src: _imports_0,
          alt: "illustration",
          class: "w-3/4 md:w-1/2"
        }, null, -1)),
        _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight" }, [
          _createTextVNode(" Welcome to "),
          _createElementVNode("span", { class: "text-indigo-600" }, "PayLog")
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-gray-600 max-w-md" }, " Your all-in-one dashboard to manage payments & users. ", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_RouterLink, { to: "/payments" }, {
            default: _withCtx(() => [
              _createVNode(_component_PrimaryButton, { "btn-txt": 'View Payments' })
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, { to: "/users" }, {
            default: _withCtx(() => [
              _createVNode(_component_SecondaryButton, { "btn-txt": 'View Users' })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}